const InputComponents: string[] = [
  'Input',
  'Radio',
  'Select',
  'TextArea',
  'Checkbox',
  'OnClickOutside(DatePicker)',
  'Typeahead',
];

export default InputComponents;
